import {
  CampaignService,
  ErrorListService,
  ProductService,
  SendgridService,
} from "@app/services";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  ViewChild,
} from "@angular/core";
import {
  DialogData,
  ModalComponent,
} from "@app/components/modal/modal.component";
import { OnChanges, Output, SimpleChanges } from "@angular/core";

import { F2FEmailFieldService } from "@app/services/f2f-email-field.service";
import { MatAccordion } from "@angular/material/expansion";
import { MatDialog } from '@angular/material/dialog';
import { PortalService } from "@app/modules/home/services/portal.service";
import { ResponseTitleComponent } from "@app/components/response-title/response-title.component";
import { TitleModalConfig } from "@app/shared/title-modal-config";

@Component({
  selector: "app-f2f-selector",
  templateUrl: "./f2f-selector.component.html",
  styleUrls: ["./f2f-selector.component.scss"],
})
export class F2fSelectorComponent {
  @Input() listData: any[];
  @Input() products: any[];
  @Output() dataEvent = new EventEmitter<any>();
  @ViewChild(MatAccordion) accordion: MatAccordion;
  fields: any[];
  submitSrvFn: any;
  saleStatus: any;
  productSelected: any;
  campaignData: any;
  data: DialogData;

  constructor(
    private campaignService: CampaignService,
    public productService: ProductService,
    public portalService: PortalService,
    private errorListService: ErrorListService,
    fieldsService: F2FEmailFieldService,
    private sendgridService: SendgridService,
    public dialog: MatDialog
  ) {
    this.campaignData = this.campaignService.getData();
    this.saleStatus = this.campaignService.getSaleStatus();
    this.fields = fieldsService.getFields(this.portalService.portalMode);
  }
  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges) {}

  goToPlans($event, prod) {
    this.dataEvent.emit({ event: { ...$event, toLanding: false }, data: prod });
  }

  openModalMail($event, product) {
    const dialogRef = this.dialog.open(ModalComponent, {
      id: "dialog-refer-call",
      autoFocus: false,
      backdropClass: "backdrop-blur",
      panelClass: "panel-mobile",
      maxHeight: "100vh",

      data: {
        title: "Enviar cotización por email a tu referido",
        description: `Confirma tu mensaje y así podremos enviar a tu referido la cotización del producto ${
          product?.label || product.name
        }.

        Esto permitirá además retomar la cotización en el momento que lo prefiera.`,
        customData: product,
        formName: "refer-call-form",
        fields: this.fields,
        submitFn: this.sendEmail,
        submitSrvFn: this.sendgridService.sendReferBGEmailData,
        submitText: "Enviar",
      },
    });
    dialogRef.componentInstance.parentEvent.subscribe((result) => {
      if (result.message == "unknownError") {
        dialogRef.close(result);
      }
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result.message == "success") {
        this.openScheduleResponse(result);
      } else if (result.message == "unknownError") {
        this.errorListService.openModalError(
          this.errorListService.getErrorByCode(
            result.data?.errorCode || "F2FBGEmail"
          )
        );
      }
    });
  }

  openScheduleResponse(typeRes): void {
    var configTitle: TitleModalConfig;
    if (typeRes.message === "success") {
      configTitle = {
        bgclass: "success",
        icon: "check_circle_outline",
        emphasisTitle: "Hemos recibido tu solicitud",
      };
    }
    const dialogRef = this.dialog.open(ModalComponent, {
      id: "dialog-refer-success",
      autoFocus: false,
      backdropClass: "backdrop-blur",
      panelClass: "panel-mobile",
      minHeight: "80vh",
      maxHeight: "100vh",

      data: {
        titleComponent: ResponseTitleComponent,
        configTitle,
        confirmHTML: "<p class=\"scroll-container__text\" style=\"width:560px;max-width:100%\">El correo de referido ha sido enviado a tu cliente.</p><img alt='Usuario interactuando con smartphone' class=\"scroll-container__img\" style='display:block;margin:0 auto;max-width:200px;width:100%' src='/assets/img/home/cellphone-modal.svg' />",
        confirmActions: {
          confirmLabel: "Aceptar",
        },
      },
    });
  }

  public async sendEmail(input) {
    const campaignData = this.campaignService.getData();
    const resultParams = this.campaignService.composeParams(campaignData);
    let amountsExp = null;
    if (this.data.customData.modal_Age) {
      const checkProds = this.productService.products.find(
        (p) => p.name == this.data.customData.relatedProducts[0]
      );
      if (checkProds) {
        amountsExp = await this.campaignService.getRangeAgeAmountsForBGEmail(
          this.data.customData.relatedProducts[0],
          campaignData?.range_age_type
        );
      } else {
        const resProds = await this.productService
          .getProductsRemote({
            product_Id: this.data.customData.relatedProducts[0],
          })
          .toPromise();
        amountsExp = await this.campaignService.getRangeAgeAmountsForBGEmail(
          this.data.customData.relatedProducts[0],
          campaignData?.range_age_type
        );
      }
    }
    var dataToSend = {
      ...input,
      textMessage: input?.textMessage || "",
      product: this.data.customData.relatedProducts[0],
      amounts: amountsExp,
      typeTemplate: this.data.customData.defaultTemplate,
      sellerId: campaignData?.seller_id,
      saleType: campaignData?.SaleType,
      channelType: campaignData?.channel_id,
      operationId: campaignData?.operation_id,
      urlParams: resultParams,
    };
    return this.submitSrvFn(dataToSend);
  }
}
